export default "__VITE_PUBLIC_ASSET__d9303fb9__"